import RestService from "@/services/RestService";

function updateHistory(lessonId, delta) {
  return RestService.sendReq("post", "histroy", {
    lesson: lessonId,
    timedelta: delta,
  });
}

export default {
  updateHistory,
};
